<div class="dialog-container">
    <div class="grid p-fluid p-input-filled dialog-row">
        <div>
            <textarea [(ngModel)]="message" pInputTextarea></textarea>
        </div>
    </div>
</div>
<div style="text-align: right;">
    <p-button icon="fa fa-times" label="Abbrechen" styleClass="p-button-text p-button-danger p-button-lg" (onClick)="cancelAsync()"></p-button>
    <p-button icon="fa fa-check" label="Nachricht senden" styleClass="p-button-text p-button-success p-button-lg" [disabled]="(canSave === false)" (onClick)="saveAsync()"></p-button>
</div>
